import {
  DataApps,
  AppsActionTypes,
  ADD_APPS,
  DELETE_APPS,
  UPDATE_APPS,
  SELECTED_ORG,
  REMOVE_SELECTED_ORG,
  UPDATE_APP_VERSION,
  UPDATE_SELECTED_APP,
  UPDATE_APP_LIST,
  UPDATE_APP_BRANCH,
  UPDATE_SELECTED_BPMN,
  UPDATE_SELECTED_DMN,
  FORM_VERSION,
  FORM_CORE_VERSION,
  UPDATE_SELECTED_AGENT_NAME
} from "./types";
import update from 'immutability-helper';

const initialState: DataApps = {
  apps: [],
  SelectedOrg: "",
  appVersion: {},
  appsList: [],
  selectedApp: {},
  appBranch: {},
  selectedBpmn: {},
  selectedDmn: {},
  formVersion: "",
  formCoreVersion: "",
  selectedAiAgentName: "",
};

export function Apps(
  state = initialState,

  action: AppsActionTypes
): DataApps {
  switch (action.type) {
    case ADD_APPS:
      return { ...state, apps: [...state.apps, ...[action.data]] };
    case DELETE_APPS:
      const dataSource = [...state.apps];
      let newdata = dataSource.filter(
        (item: any) => item.id !== action.data.id
      );
      return { ...state, apps: [...newdata] };
    case UPDATE_APPS:
      const index = state.apps.findIndex(
        (post: any) => post.id === action.data.id
      );
      let updatedApps = state.apps.map((content: any, i) =>
        i === index ? { ...content, ...action.data } : content
      );
      return { ...state, apps: updatedApps };
    case SELECTED_ORG:
      return { ...state, SelectedOrg: action.data };
    case REMOVE_SELECTED_ORG:
      return { ...state, SelectedOrg: "" };
    case UPDATE_APP_VERSION:
      return {
        ...state,
        appVersion: {
          ...state.appVersion,
          [action.data.key]: action.data.value
        }
      }
    case UPDATE_APP_BRANCH:
      return {
        ...state,
        appBranch: {
          ...state.appBranch,
          [action.data.key]: action.data.value
        }
      }
    case UPDATE_SELECTED_APP:
      return {
        ...state,
        selectedApp: { ...action.data }
      }
    case UPDATE_APP_LIST:
      return {
        ...state,
        appsList: [...action.data]
      }
    case UPDATE_SELECTED_BPMN:
      return {
        ...state,
        selectedBpmn: action.data[0]
      }
    case UPDATE_SELECTED_DMN:
      return {
        ...state,
        selectedDmn: action.data
      }
    case FORM_VERSION:
      return update(state, {
        formVersion: { $set: action.data }
      });
    case FORM_CORE_VERSION:
      return update(state, {
        formCoreVersion: { $set: action.data}
      })
    case UPDATE_SELECTED_AGENT_NAME:
      return {
        ...state,
        selectedAiAgentName: action.data
      }
    default:
      return state;
  }
}
